import styles from "./ProjectsHeader.module.css";

export const ProjectsHeader = () => {
  return (
    <>
      <div className={styles.projects_header}></div>
      <div className={styles.projects_header_title}>
        <h2>PROJECTS</h2>
      </div>
    </>
  );
};
